module.exports = __webpack_public_path__ + "static/media/solent.de57b01e.webp";